import { render, staticRenderFns } from "./BroadCast.vue?vue&type=template&id=0a59882c&scoped=true&"
import script from "./BroadCast.vue?vue&type=script&lang=js&"
export * from "./BroadCast.vue?vue&type=script&lang=js&"
import style0 from "./BroadCast.vue?vue&type=style&index=0&id=0a59882c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a59882c",
  null
  
)

export default component.exports